// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_1IF9c","content":"_2CeGU","left-content":"_3YCSF","author-datetime-content":"_1YnzQ","section-name":"_1LjPT","divider":"_3uPqw"};